import { render } from "./VabeneAddProgrammePage.vue?vue&type=template&id=903c99c6&ts=true"
import script from "./VabeneAddProgrammePage.vue?vue&type=script&lang=ts"
export * from "./VabeneAddProgrammePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__